"use client";
import SeachFormsCampaignListener from "@/components/SeachFormsCampaignListener";
import BottomSheet from "@/components/ui/BottomSheet";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { getCdnImagePath } from "@/utils/bus/getCdnImagePath";
import clsx from "clsx";
import Image from "next/image";
import { useState } from "react";

const LayoutWrapper = ({
  children,
  pnrFormComponent: PnrFormComponent,
  checkInFormComponent: CheckInFormComponent,
  translationNamespace = "common",
  hidePnrSection,
  showCampaignSection = true,
  wrapperClassName,
}) => {
  const t = useTranslationDetector();
  const [isPnrModalOpen, setIsPnrModalOpen] = useState(false);
  const [isCheckInModalOpen, setIsCheckInModalOpen] = useState(false);

  const handlePnrClick = () => {
    setIsPnrModalOpen(true);
  };

  const handleCheckInClick = () => {
    setIsCheckInModalOpen(true);
  };

  const closePnrModal = () => {
    setIsPnrModalOpen(false);
  };

  const closeCheckInModal = () => {
    setIsCheckInModalOpen(false);
  };

  // BottomSheet handles mobile gating, animations and body scroll lock internally

  return (
    <div className={clsx("flex flex-col gap-4 sm:gap-6", wrapperClassName)}>
      {/* Ana form */}
      {children}

      {showCampaignSection && (
        <SeachFormsCampaignListener wrapperClassName="order-1 sm:order-2" />
      )}

      {/* Mobile PNR & Check-In Butonları */}

      {!hidePnrSection && (
        <div className="shadow-small order-2 flex items-center justify-center rounded-lg bg-white/90 sm:order-1 md:hidden">
          <button
            onClick={handlePnrClick}
            className="inline-flex w-1/2 items-center justify-center gap-4 p-6 text-sm font-medium"
          >
            <Image
              src={getCdnImagePath("/saka/common/svg/onlinecancel.svg")}
              className="h-10 w-10 object-cover"
              alt={t(`${translationNamespace}.pnrSearch`)}
              width={40}
              height={40}
            />

            <span className="flex-1 text-left sm:flex-none">
              {t(`${translationNamespace}.reservationSearch`)}
            </span>
          </button>
          <span className="bg-primary-weak h-[42px] w-[0.66px]"></span>
          <button
            onClick={handleCheckInClick}
            className="inline-flex w-1/2 items-center justify-center gap-4 p-6 text-sm font-medium"
          >
            <Image
              src={getCdnImagePath("/saka/common/svg/cancelhotel.svg")}
              className="h-10 w-10 object-cover"
              alt={t(`${translationNamespace}.checkIn`)}
              width={39}
              height={31}
            />
            <span className="flex-1 text-left sm:flex-none">
              {t(`${translationNamespace}.onlineCancel`)}
            </span>
          </button>
        </div>
      )}

      {/* PNR BottomSheet */}
      {PnrFormComponent && (
        <BottomSheet
          isOpen={isPnrModalOpen}
          onClose={closePnrModal}
          title={t(`${translationNamespace}.reservationSearch`)}
          borderClassName="border-b-0"
        >
          <PnrFormComponent onClose={closePnrModal} />
        </BottomSheet>
      )}

      {/* Check-In BottomSheet */}
      {CheckInFormComponent && (
        <BottomSheet
          isOpen={isCheckInModalOpen}
          onClose={closeCheckInModal}
          title={t(`${translationNamespace}.onlineCancel`)}
          borderClassName="border-b-0"
        >
          <CheckInFormComponent onClose={closeCheckInModal} />
        </BottomSheet>
      )}
    </div>
  );
};

export default LayoutWrapper;
